var $b581497e2cb602cb$exports = {};
$b581497e2cb602cb$exports = {
    "breadcrumbs": `Miez de p\xe2ine`
};


export {$b581497e2cb602cb$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
